import React from 'react';
import './TableRenderer.css'; // Let's use existing global table classes if possible, but localized overrides here

const TableRenderer = ({ data, config, compact }) => {
  const { columns = [], highlightColumn } = config || {};

  if (!data || !Array.isArray(data) || data.length === 0) {
    return <div className="dc-no-data">No table data available</div>;
  }

  // If columns not specified, use keys of first object
  const cols = columns.length > 0 ? columns : Object.keys(data[0]);

  return (
    <div className={`dc-table-container custom-scrollbar ${compact ? 'compact' : ''}`}>
      <table className="table dc-table">
        <thead>
          <tr>
            {cols.map(col => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {cols.map(col => (
                <td key={col} className={col === highlightColumn ? 'highlight font-bold text-primary' : ''}>
                  {row[col]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableRenderer;
